import React, { useEffect } from "react";
import { classNames } from "../../helpers/classNames";

const Radio = ({
  radioName,
  radioInputClass,
  isChecked,
  radioLabel,
  radioLableClass,
  value,
  className,
  radiopeerbutton,
  onChange = () => { },
  id,
  ...props
}) => {
  return (
    <label htmlFor={id}>
      <div
        className={classNames(
          "relative overflow-hidden flex items-center",
          className
        )}
      >
        <input
          type="radio"
          name={radioName}
          className={
            "peer absolute top-0 left-0 w-5 h-5 opacity-0 z-10 cursor-pointer " +
            radioInputClass
          }
          checked={isChecked}
          onChange={onChange}
          value={value}
          id={id}
        />
        <div
          className={classNames(
            "relative w-5 h-5 min-w-[20px] border border-slate-300 rounded-full flex items-center justify-center text-[10px] bg-surface-03 text-black/0 peer-checked:bg-white peer-checked:border-primary peer-checked:before:bg-primary before:content-[''] before:absolute before:top-1/2 before:left-0 before:w-3 before:h-3 before:rounded-full before:-translate-y-[50%] before:right-0 before:mx-auto",
            radiopeerbutton
          )}
        ></div>
        {radioLabel && (
          <div
            className={
              "text-xs text-sidebar w-full     ml-3 " +
              radioLableClass
            }
          >
            {radioLabel}
          </div>
        )}
      </div>
    </label>
  );
};

export default Radio;
